export default __webpack_public_path__ + "static/media/img-0195-columbia-full-face.f80ea152.png";